// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"248":"92740150e1687b63","280":"89b23f6932787569","600":"537126da00186bf5","908":"b5acdbf2ab3e1427","952":"1ea2e322ad6e33dd"}[chunkId] + ".js";
};